export const forms = {
	validation: {
		required: "{{field}} er påkrævet",
		min: "{{field}} skal være mindst {{min}} tegn",
		max: "{{field}} må højst være {{max}} tegn",
		invalid: "{{field}} er ikke gyldig",
		lowercase: "{{field}} måste innehålla minst en liten bokstav",
		uppercase: "{{field}} måste innehålla minst en stor bokstav",
		number: "{{field}} måste innehålla minst en siffra",
		special_character: "{{field}} måste innehålla minst ett specialtecken",
	},
	email: {
		label: "E-mail",
		placeholder: "you@example.se",
	},
	password: {
		label: "Adgangskode",
		placeholder: "Indtast adgangskode",
		password_match: "Lösenorden måste matcha",
	},
	first_name: {
		label: "Förnamn",
		placeholder: "John",
	},
	last_name: {
		label: "Efternamn",
		placeholder: "Doe",
	},
};
